// extracted by mini-css-extract-plugin
module.exports = {"toggle-container":"ToggleInput_toggle-container__SCcfI","toggle-button":"ToggleInput_toggle-button__onGHE","hidden-input":"ToggleInput_hidden-input__eCdwj"};